import { Outlet } from 'react-router-dom';

import DashboardLayout from '../../shared/components/ui/dashboard-layout';

const Approvals = () => {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export default Approvals;
